export default "__VITE_ASSET__d2c6a4da__"